import { Box } from '@mui/material'

export const SpaceBox = (): JSX.Element => <Box sx={{ flexGrow: 1 }} />
